import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory } from "@mijalowcode/types";

export const ScenarioFlowBoardMeta: ComponentMeta = {
  componentName: "ScenarioFlowBoard",
  package: "custom",
  title: "场景流程看板",
  description: "用于承载场景物料的容器",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "ApartmentOutlined",
  canHaveChildren: true,
  acceptedChildren: ["ScenarioFlowScene"],
  editorDnd: {
    draggable: true,
  },
  props: [],
  npm: {
    package: "@mijalowcode/materials",
    exportName: "ScenarioFlowBoard",
  },
  snippet: {
    componentName: "ScenarioFlowBoard",
    package: "custom",
    children: [
      {
        componentName: "ScenarioFlowScene",
        package: "custom",
        props: {
          sceneId: "scene-1",
          title: "场景1:认可商保理算",
        },
        children: [
          {
            componentName: "ScenarioFlowStep",
            package: "custom",
            props: {
              flowId: "HC4000",
              code: "HC4000",
              status: "error",
            },
          },
          {
            componentName: "ScenarioFlowStep",
            package: "custom",
            props: {
              flowId: "HC291",
              code: "HC291",
              status: "pending",
            },
          },
        ],
      },
      {
        componentName: "ScenarioFlowScene",
        package: "custom",
        props: {
          sceneId: "scene-2",
          title: "场景2:不认可商保理算",
        },
        children: [
          {
            componentName: "ScenarioFlowStep",
            package: "custom",
            props: {
              flowId: "HC5200",
              code: "HC5200",
              status: "pending",
            },
          },
        ],
      },
    ],
  },
};
